enum TaskTypeEnum {
  FEEDBACK = "FEEDBACK",
  FINAL_AMOUNT = "FINAL_AMOUNT",
  AUCTION_END_PAYMENT = "AUCTION_END_PAYMENT",
  AUCTION_END_TRANSPORT = "AUCTION_END_TRANSPORT",
  CLAIM = "CLAIM",
  APPROVE_CONTRACT = "APPROVE_CONTRACT",
  TRANSPORT_SELECTION = "TRANSPORT_SELECTION",
  APPROVE_ORDER = "APPROVE_ORDER",
  FINAL_WEIGHT = "FINAL_WEIGHT",
  REGISTER_SERVICE_VALUE = "REGISTER_SERVICE_VALUE",
  COLLECTIVE_INVOICING = "COLLECTIVE_INVOICING",
  FINAL_AMOUNT_MULTIPLE = "FINAL_AMOUNT_MULTIPLE",
  CREDIT_REQUEST = "CREDIT_REQUEST",
  ARCHIVE_CONTRACT = "ARCHIVE_CONTRACT",
  CONTRACT_EXPIRING = "CONTRACT_EXPIRING",
  PROCESS_ORDER = "PROCESS_ORDER",
  COLLECTION = "COLLECTION",
}

export default TaskTypeEnum;
